import clsx from "clsx"
import { useState } from "react"

import { type SX, theme } from "../../theme/new"
import styles from "./Video.module.css"

export interface VideoProps {
  src: string
  loop?: boolean
  autoPlay?: boolean
  sizing?: "contain" | "cover" | "none"
  borderRadius?: 0 | 4
  boxShadow?: "3"
  animateOnLoad?: boolean
  /**
   * Whether to show the playback controls. Defaults to true.
   */
  withControls?: boolean
  sx?: SX
  onLoad?: () => void
}

/*
 * A Basic Video that can play an enter animation when it loads.
 */
export function Video(props: VideoProps) {
  const {
    src,
    onLoad,
    sizing = "none",
    borderRadius = 0,
    boxShadow,
    withControls = true,
    animateOnLoad = true,
    sx,
    ...otherProps
  } = props

  const [isLoaded, setIsLoaded] = useState(false)

  function getLoadingState() {
    if (!animateOnLoad) return undefined
    if (isLoaded) return "loaded"
    return "loading"
  }

  const loadingState = getLoadingState()

  function onVideoLoad() {
    setIsLoaded(true)
    onLoad?.()
  }

  return (
    <video
      {...otherProps}
      controls={withControls}
      className={clsx(
        styles[`sizing-${sizing}`],
        styles[`borderRadius-${borderRadius}`],
        loadingState && styles[loadingState]
      )}
      style={{ ...sx, boxShadow: boxShadow && theme.boxShadow[boxShadow] }}
      onLoadedData={onVideoLoad}
    >
      <source src={src} type="video/mp4" />
      <track kind="captions" />
    </video>
  )
}
